import Chart from "../charts/chart";


const ExpenseChart = (props) => {
  const chartDataPoints=[
    {label:'Jan',value:0},
    {label:'Fed',value:0},
    {label:'Mar',value:0},
    {label:'Apr',value:0},
    {label:'May',value:0},
    {label:'Jun',value:0},
    {label:'Jul',value:0},
    {label:'Aug',value:0},
    {label:'Sep',value:0},
    {label:'Oct',value:0},
    {label:'Nov',value:0},
    {label:'Dec',value:0},
  ];
  for(const expenses of props.expense){
    const expenseMonth  =expenses.thatDay.getMonth();  //Strating at 0 =>Januvary =>0
    chartDataPoints[expenseMonth].value += expenses.rate;
  }
  console.log(chartDataPoints);

  return (  
    <div>
      <Chart dataPoints = {chartDataPoints}/>
    </div>
  );
}
 
export default ExpenseChart;